// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-components-home-home-section-title----home-section-title-module---wrapper---2i9UV","copy":"src-components-home-home-section-title----home-section-title-module---copy---2VHMo","white":"src-components-home-home-section-title----home-section-title-module---white---1Lg08","dash":"src-components-home-home-section-title----home-section-title-module---dash---1zSjy","dashWhite":"src-components-home-home-section-title----home-section-title-module---dashWhite---2g_p0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/home/home-section-title/home-section-title.module.css
// module id = 496
// module chunks = 35783957827783